import type { ReactElement } from 'react';
import { Icon } from '../icons/index.js';

/**
 * §11 — historical serialisation. A snapshot is a frozen copy taken when the
 * contract was agreed; rendering it identically to live data is how a March
 * bill acquires an April rate. This marker is the visual contract that stops it.
 */
export function FrozenMarker({ label = 'Agreed terms' }: { label?: string }): ReactElement {
  return (
    <span className="frozen" title="Recorded when this was agreed. It does not change.">
      {/* A drawing from the product's own set, not an emoji. An emoji is a
          different typeface at a different weight rendered by the operating
          system, so it is the one glyph on the screen the design system does
          not control — and on Android it is a different picture entirely. */}
      <Icon name="frozen" size="sm" />
      {label}
    </span>
  );
}

/**
 * OD-6 is unresolved, so tax and commission are not computable and NO total is
 * complete. Every money figure that could be mistaken for final carries this.
 */
export function ProvisionalMarker({
  label = 'Provisional',
  reason = 'Taxes and platform fees are not applied yet.',
}: {
  label?: string;
  reason?: string;
}): ReactElement {
  return (
    <span className="provisional" title={reason}>
      {label}
    </span>
  );
}
